import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useApiVersionQuery } from 'api';
import { Routes } from 'utils';
import { Preloader } from 'components';
import LogoSrc from 'assets/images/logo.svg';

import './maintenance-page.less';

const MaintenancePage = () => {
  const { stopPolling, data, loading } = useApiVersionQuery({
    pollInterval: 60000,
    fetchPolicy: 'no-cache',
  });

  useEffect(
    () => () => {
      stopPolling();
    },
    [stopPolling]
  );

  if (loading) {
    return <Preloader show />;
  }

  if (data) {
    return <Redirect to={Routes.Dashboard} />;
  }

  return (
    <div className="page-container">
      <div className="page-card">
        <div className="app-logo__lg">
          <img src={LogoSrc} alt="logo" />
        </div>
        <div>
          <h1 className="page-card__header">We&apos;ll be back soon</h1>
        </div>
        <div className="page-card__text">
          <span>
            We&apos;re very sorry for the inconvenience, but we&apos;reP
            performing maintenance. Please check back soon.
          </span>
          <br />
          <br />
          <span>- The HireAction Team</span>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
